import moment from "moment";

export function dateComparator(date1, date2) {
    const dateOne = moment(date1).isValid() ? moment(date1) : null;
    const dateTwo = moment(date2).isValid() ? moment(date2) : null;

    if (dateOne === null && dateTwo === null) {
        return 0;
    }
    if (dateOne === null) {
        return -1;
    }
    if (dateTwo === null) {
        return 1;
    }
    return dateOne - dateTwo;
}